import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { assertEx } from '@xylabs/sdk-js'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
// eslint-disable-next-line no-restricted-imports
import MapBox, { CircleLayer, GeoJSONSource } from 'mapbox-gl'
import { useContext } from 'react'

import { MinterAuctionContext } from '../Contexts'
import { GeoJsonMapBox } from './GeoJsonMap'

interface MapZoomDialogProps {
  onClose?: () => void
  open?: boolean
  quadkey?: Quadkey
}

const DialogOpen: React.FC<MapZoomDialogProps> = (props) => {
  const minterAuctionContext = useContext(MinterAuctionContext)
  const { onClose, open = false } = props
  const quadkey = props.quadkey ?? minterAuctionContext.quadkey
  const auction = minterAuctionContext.auction

  const geoJsonPolygonFeatureCollection = auction?.toGeoJsonPolygonFeatureCollection()

  const layerOne = 'clusters'
  const layerOneSource = 'geotoken-points'

  const addLayerOne = (map: MapBox.Map) => {
    const features = geoJsonPolygonFeatureCollection
    if (features) {
      const existingSource = map.getSource(layerOneSource) as GeoJSONSource
      if (existingSource) {
        existingSource.setData(assertEx(features))
      } else {
        map.addSource(layerOneSource, {
          data: features,
          type: 'geojson',
        })
      }
      if (!map.getLayer(layerOne)) {
        const layer: CircleLayer = {
          filter: ['has', 'point_count'],
          id: 'clusters',
          paint: {
            'circle-color': ['step', ['get', 'point_count'], '#51bbd6', 100, '#f1f075', 750, '#f28cb1'],
            'circle-radius': ['step', ['get', 'point_count'], 20, 100, 30, 750, 40],
          },
          source: 'geotoken-points',
          type: 'circle',
        }
        map.addLayer(layer)
      }
    }
  }

  const onUpdateGeoJson = (map: MapBox.Map) => {
    addLayerOne(map)
  }

  return (
    <Dialog maxWidth={false} onClose={onClose} open={open}>
      <DialogTitle>GeoJsonMap Viewer</DialogTitle>
      <DialogContent>
        <GeoJsonMapBox height={320} width={320} updateGeoJson={onUpdateGeoJson} quadkey={quadkey} ready={!!geoJsonPolygonFeatureCollection} />
      </DialogContent>
      <DialogActions>
        <Box display="flex" width="100%">
          <Box>
            <Button onClick={onClose} variant="text">
              Close
            </Button>
          </Box>
          <Box flexGrow={1}></Box>
          <Box>
            <Button onClick={onClose} variant="text">
              Ok
            </Button>
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

const GeoJsonMapDialog: React.FC<MapZoomDialogProps> = (props) => {
  const { open } = props
  if (open) {
    return <DialogOpen {...props} />
  } else {
    return null
  }
}

export default GeoJsonMapDialog
